import React, {useState, useRef, useLayoutEffect, useEffect, useMemo, useCallback} from 'react';
import Select, { components } from 'components/common/AppSelect'
import { observer } from 'mobx-react'
import './index.css';
import GlobalState, {addModels, changeActiveModel, changeActiveSegmentThreshold, changepopupaddAttachmentAnalitics, changeActiveModelLastTrain, changeActiveThreshold} from "../../stores/GlobalState";
import Pool from "../autorize/UserPool";
import Domen from "../../stores/Domen";
import Loading from '../common/loading';
import LoadingCompleted from '../common/loading_completed';
import LoadingFail from '../common/loading_fail';
import LoadingFailDetail from '../common/loading_fail_detail';
import Accuracy from '../common/accuracy';
import AccuracyNo from '../common/accuracyNoTresh';
import Contop from '../common/contop';
import ContopNo from '../common/contopNoTresh';
import TabsTarget from '../common/tabstarget';
import TabsTargetNo from '../common/tabstargetNoTresh';
import Fourblock from '../common/fourblock';
import TopField from '../common/topfield';
import Priview from '../common/preview';
import Metric from '../common/metric';
import lang from "../../lang"
import ThresholdSlider from "../common/thresholdSlider"
import CreateSegmentationBlock from "../segmentation/CreateSegmentationBlock";
import SegmentSlider from "./segmentSlider"
import { TestingSegmentsLoopSwap } from "./testingSegmentsIcon";
const STEP = 0.05;

const LeftIcon = () => (<svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.37577 0.492879L7.37577 9.35961C7.37548 9.44938 7.35073 9.53738 7.30415 9.61412C7.25758 9.69087 7.19096 9.75346 7.11146 9.79516C7.03196 9.83686 6.9426 9.85609 6.85298 9.85078C6.76337 9.84547 6.6769 9.81582 6.60288 9.76502L0.199132 5.33165C-0.0663773 5.14791 -0.0663773 4.70556 0.199132 4.52133L6.60288 0.0879644C6.67674 0.0366482 6.76326 0.00655512 6.85302 0.000954807C6.94278 -0.0046455 7.03237 0.0144611 7.11203 0.0561989C7.1917 0.0979366 7.25841 0.160709 7.3049 0.237696C7.3514 0.314683 7.37591 0.40294 7.37577 0.492879Z" fill="black"/>
</svg>
);
const RightIcon = () => (<svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-3.38554e-05 0.492879L-3.38554e-05 9.35961C0.000247478 9.44938 0.0250068 9.53738 0.071579 9.61412C0.118151 9.69087 0.184771 9.75346 0.26427 9.79516C0.343769 9.83686 0.433136 9.85609 0.52275 9.85078C0.612365 9.84547 0.698833 9.81582 0.77285 9.76502L7.1766 5.33165C7.44211 5.14791 7.44211 4.70556 7.1766 4.52133L0.77285 0.0879644C0.698988 0.0366482 0.612475 0.00655512 0.522712 0.000954807C0.432948 -0.0046455 0.343366 0.0144611 0.263699 0.0561989C0.184031 0.0979366 0.117325 0.160709 0.0708289 0.237696C0.0243325 0.314683 -0.000175476 0.40294 -3.38554e-05 0.492879Z" fill="black"/>
</svg>
);

function roundToStep(value, step) {
  return Math.round(value / step) * step;
}

function sameStep(a, b, step = STEP) {
  // щоб не впіймати баги з float типу 0.1500000000002
  return Math.abs(roundToStep(a, step) - roundToStep(b, step)) < 1e-9;
}
const user = Pool.getCurrentUser();

function normalizeThresholdPair(lowerValue, upperValue, fallback = 0.5) {
  let L = Number(lowerValue);
  let U = Number(upperValue);

  if (!Number.isFinite(L)) L = fallback;
  if (!Number.isFinite(U)) U = fallback;

  L = Math.max(0, Math.min(1, roundToStep(L, STEP)));
  U = Math.max(0, Math.min(1, roundToStep(U, STEP)));

  if (L > U) [L, U] = [U, L];

  return { lower: L, upper: U };
}

const calcObservationTotal = (selected, sourceOptions = []) => {
    return (selected || []).reduce((sum, item) => {
        if (item && typeof item === "object" && item.pct != null) {
            return sum + (Number(item.pct) || 0);
        }

        const rawValue =
            typeof item === "string"
                ? item
                : item?.value ?? item?.key ?? null;

        if (!rawValue) return sum;

        const found = sourceOptions.find(
            (opt) => opt.value === rawValue || opt.key === rawValue
        );

        return sum + (Number(found?.pct) || 0);
    }, 0);
};

// const THRESH_COOKIE_PREFIX = "thresholds:";

// function setCookie(name, value, days = 365) {
//   const maxAge = days * 24 * 60 * 60; // seconds
//   document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
// }

// function getCookie(name) {
//   const encodedName = encodeURIComponent(name) + "=";
//   const parts = document.cookie.split("; ");
//   for (const part of parts) {
//     if (part.startsWith(encodedName)) {
//       return decodeURIComponent(part.slice(encodedName.length));
//     }
//   }
//   return null;
// }

// function safeClamp01(x) {
//   const n = Number(x);
//   if (!Number.isFinite(n)) return null;
//   if (n < 0) return 0;
//   if (n > 1) return 1;
//   return n;
// }

function pad2(value) {
    return String(value).padStart(2, "0");
}

function normalizeDateLike(input) {
    if (input == null) {
        return {
            key: "",
            hasTime: false,
            display: "",
        };
    }

    const str = String(input).trim();
    if (!str) {
        return {
            key: "",
            hasTime: false,
            display: "",
        };
    }

    // unix timestamp: seconds or milliseconds
    if (/^\d{10,13}$/.test(str)) {
        const num = Number(str);
        const ms = str.length === 13 ? num : num * 1000;
        const d = new Date(ms);

        if (!Number.isNaN(d.getTime())) {
            const year = d.getFullYear();
            const month = pad2(d.getMonth() + 1);
            const day = pad2(d.getDate());
            const hh = pad2(d.getHours());
            const mm = pad2(d.getMinutes());
            const ss = pad2(d.getSeconds());

            const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

            return {
                key: hasTime
                    ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                    : `${year}-${month}-${day}`,
                hasTime,
                display: hasTime
                    ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                    : `${day}.${month}.${year}`,
            };
        }
    }

    // YYYY-MM-DD or YYYY/MM/DD + optional time
    let m = str.match(
        /^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})(?:[T\s](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/
    );
    if (m) {
        const [, y, mo, d, h = "00", mi = "00", s = "00"] = m;

        const year = y;
        const month = pad2(mo);
        const day = pad2(d);
        const hh = pad2(h);
        const mm = pad2(mi);
        const ss = pad2(s);

        const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

        return {
            key: hasTime
                ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                : `${year}-${month}-${day}`,
            hasTime,
            display: hasTime
                ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                : `${day}.${month}.${year}`,
        };
    }

    // DD.MM.YYYY / DD-MM-YYYY / DD/MM/YYYY + optional time
    m = str.match(
        /^(\d{1,2})[./-](\d{1,2})[./-](\d{4})(?:[T\s](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/
    );
    if (m) {
        const [, d, mo, y, h = "00", mi = "00", s = "00"] = m;

        const year = y;
        const month = pad2(mo);
        const day = pad2(d);
        const hh = pad2(h);
        const mm = pad2(mi);
        const ss = pad2(s);

        const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

        return {
            key: hasTime
                ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                : `${year}-${month}-${day}`,
            hasTime,
            display: hasTime
                ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                : `${day}.${month}.${year}`,
        };
    }

    // fallback through Date()
    const parsed = new Date(str);
    if (!Number.isNaN(parsed.getTime())) {
        const year = parsed.getFullYear();
        const month = pad2(parsed.getMonth() + 1);
        const day = pad2(parsed.getDate());
        const hh = pad2(parsed.getHours());
        const mm = pad2(parsed.getMinutes());
        const ss = pad2(parsed.getSeconds());

        const hasTime = hh !== "00" || mm !== "00" || ss !== "00";

        return {
            key: hasTime
                ? `${year}-${month}-${day} ${hh}:${mm}:${ss}`
                : `${year}-${month}-${day}`,
            hasTime,
            display: hasTime
                ? `${day}.${month}.${year} ${hh}:${mm}:${ss}`
                : `${day}.${month}.${year}`,
        };
    }

    return {
        key: str,
        hasTime: false,
        display: str,
    };
}

const Addmodels = observer(({activemodel, setAddmodel, load, setLoad}) => {
    const [obsLoading, setObsLoading] = useState(false);
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [optionfields, setOptionfields] = useState([]);
    const [metadata, setMetadata] = useState([]);
    const [namemodal, setNamemodal] = useState(activemodel.name);
    const [countmodal, setCountmodal] = useState(GlobalState.activemodel?.lastTrain?.learningCyclesCount);
    const [optiontype, setOptiontype] = useState(GlobalState.activemodel?.lastTrain?.learningType);
    const [optionmetrics, setOptionmetrics] = useState(GlobalState.activemodel?.lastTrain?.featureDatasetName);
    const [optiontarget, setOptiontarget] = useState(GlobalState.activemodel?.lastTrain?.targetDatasetName);
    const [optiontargetfields, setOptiontargetfields] = useState(GlobalState.activemodel?.lastTrain?.objectId);
    const [disablebut, setDisablebut] = useState(true)
    const [optionscsw, setOptionscsw] = useState("");
    const [newTabs, setNewTabs] = useState(0);
    const [selectsOp, setselectsOp] = useState(false);
    const [activeSegmentMeta, setActiveSegmentMeta] = useState(null);
    const [isAdditionalTesting, setIsAdditionalTesting] = useState(false);
    const menuListElRef = useRef(null);
    const menuScrollTopRef = useRef(0);
    const [obsMenuOpen, setObsMenuOpen] = useState(false);
    const [featureDataset, setFeatureDataset] = useState(null);
    const [targetDataset, setTargetDataset] = useState(null);
    const [observationOptionsApi, setObservationOptionsApi] = useState([]);
    const [isTargetDatasetChanged, setIsTargetDatasetChanged] = useState(false);
            
    
    
    const [segments, setSegments] = useState([
        // { id: crypto.randomUUID(), name: "Segment 1", pct: 0 }, // приклад поля pct
    ]);

    const [activetab, setActivetab] = useState(0);
    const [editingId, setEditingId] = useState(null);
    const [editingMeta, setEditingMeta] = useState({ id: null, original: "" });
    
    const isNewSegment = typeof activetab === "string" && activetab.includes("test");

    console.log("User: "+ JSON.stringify(user));
    useEffect(() => {
        const metrics = GlobalState.activemodel?.lastTrain?.metrics;

        if (Array.isArray(metrics)) {
            const mapped = metrics.map(item => ({
            id: item.id,
            name: item.name
            }));

            setSegments(mapped);
        } else {
            setSegments([]);
        }
    }, [GlobalState.activemodel]);    

    function getNextSegmentName(segments) {
        if (!Array.isArray(segments) || segments.length === 0) return "Segment 1";

        let maxNum = 0;

        for (const s of segments) {
            const name = (s?.name ?? s?.title ?? s?.segmentName ?? "").toString().trim();
            if (!name) continue;

            // шукаємо "Segment <number>" (регістр неважливий)
            const m = name.match(/^segment[\s_-]*(\d+)\s*$/i);
            if (!m) continue;

            const n = Number(m[1]);
            if (Number.isFinite(n) && n > maxNum) maxNum = n;
        }

        return `Segment ${maxNum + 1}`;
    }

    const addSegment = () => {
        const nextId = ((segments.at(-1)?.id ?? 0) + 205) + "test";
        const nextIndex = segments.length + 1;
        const newName = getNextSegmentName(segments);
        const newSegment = {
            id: nextId,
            name: newName,
            pct: 0
        };
        setLoad(5);
        setActiveSegmentMeta(null)
        setSegments(prev => [...prev, newSegment]);
        setActivetab(nextId); // робимо активним одразу
    };
    const addNewTabs = ()=>{
        setNewTabs(newTabs+1);
    }
    const selectSegment = (id) =>{ 
        changeActiveSegmentThreshold(id);
        setActivetab(id);
        setLoad(3);
    };
    const selectSegmentGen = (id) =>{ 
        changeActiveSegmentThreshold(0);
        getMetrix(id);
       // setLoad(3);
    };

    useEffect(() => {
        const segId = segments.find(s => s.id === activetab)?.id;
        if (segId) getMetrix(segId);
    }, [activetab, segments.length]);


    const startEdit = (id) => {
        const original = segments.find(s => s.id === id)?.name || "";
        setEditingMeta({ id, original });
        setEditingId(id);
    };

    const finishEdit = async (id) => {
        setEditingId(null);

        // якщо це не бекенд-сегмент -> нічого не робимо
        if (typeof id !== "string") return;

        const current = (segments.find(s => s.id === id)?.name || "").trim();
        const original = (editingMeta.original || "").trim();

        // якщо ім'я не змінилось -> не спамимо PUT
        if (!current || current === original) return;

        await updateSegmentName(id, current);
    };
    const changeName = (id, value) => {
        setSegments(prev => prev.map(s => (s.id === id ? { ...s, name: value } : s)));
    };
   

    // const  deleteSegment = async (id) => {
    //     setLoad(1);
    //     setSegments(prev => {
    //         const idx = prev.findIndex(s => s.id === id);
    //         const next = prev.filter(s => s.id !== id);

    //         // якщо видаляємо активний, переключаємось на сусідній
    //         if (activetab === id) {
    //             const candidate = next[idx] || next[idx - 1] || null;
    //             setActivetab(candidate?.id ?? 0);
    //         }
    //         // якщо редагували цей сегмент, вимикаємо редагування
    //         if (editingId === id) setEditingId(null);

    //         return next;
    //     });
    //     if (id.includes("test"))
    //     { }
    //     else{
    //      var token = localStorage.getItem("token");
    //         localStorage.setItem("countactivetime", Date.now());
    //         const response = await fetch(Domen.url + `model/`+GlobalState.activemodel?.id+'/metrics/'+id, {
    //             method: 'DELETE',
    //             headers: {
    //                 'Authorization': token,
    //                 'Content-Type': 'application/json',
    //             }
    //         })
    //         if(response.status=="204")
    //         {   
    //              getModel(GlobalState.activemodel?.id);
    //         }
    //     }
    // };

    const deleteSegment = async (id) => {
        setLoad(1);

        const currentSegments = [...segments];
        const idx = currentSegments.findIndex((s) => s.id === id);
        const nextSegments = currentSegments.filter((s) => s.id !== id);

        let nextActiveTab = activetab;

        // якщо видаляємо саме активний таб
        if (activetab === id) {
            const candidate = nextSegments[idx] || nextSegments[idx - 1] || null;
            nextActiveTab = candidate?.id ?? 0;
        }

        setSegments(nextSegments);
        setActivetab(nextActiveTab);

        if (editingId === id) {
            setEditingId(null);
        }

        if (String(id).includes("test")) {
            setLoad(3);
            return;
        }

        const token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());

        const response = await fetch(
            Domen.url + `model/` + GlobalState.activemodel?.id + '/metrics/' + id,
            {
                method: 'DELETE',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            }
        );

        if (response.status == 204 || response.status == "204") {
            // await getModel(GlobalState.activemodel?.id);
        } else {
            setLoad(4);
        }
    };



    const [disabletitle, setDisabletitle] = useState(false)
    const [disablebody, setDisablebody] = useState(false)

    let options = [];
    let optionstype = [{value: "binary", label: "Binary"}, {value: "multiclass", label: "Multiclass"}, {value: "regression", label: "Regression"}];
    let optionsstep = [{value: "1", label: "1"},{value: "2", label: "2"},{value: "3", label: "3"},{value: "4", label: "4"},{value: "5", label: "5"},{value: "10", label: "10"},{value: "15", label: "15"},{value: "20", label: "20"},];
    
    GlobalState.dataset?.map((n, id)=>
        options = [...options, { value: n.id, label: n.name }]
    )

    // --- Additional testing period: observation dates multiselect ---
    const observationOptions = useMemo(() => {
    // приклад як на скрінах; можеш замінити на свої дані з API/GlobalState
    return [
        { value: "10.03.2025", label: "10.03.2025 (10%)", pct: 10 },
        { value: "12.03.2025", label: "12.03.2025 (20%)", pct: 20 },
        { value: "20.03.2025", label: "20.03.2025 (30%)", pct: 30 },
        { value: "01.04.2025", label: "01.04.2025 (10%)", pct: 10 },
        { value: "10.04.2025", label: "10.04.2025 (10%)", pct: 10 },
        { value: "20.04.2025", label: "20.04.2025 (20%)", pct: 20 },
    ];
    }, []);

    const [observationSelected, setObservationSelected] = useState([
        observationOptions[0],
        observationOptions[2],
    ]);

    const [observationError, setObservationError] = useState(false);

    // const observationTotal = useMemo(() => {
    //     return (observationSelected || []).reduce((sum, o) => sum + (o.pct || 0), 0);
    // }, [observationSelected]);

    // const observationTotal = useMemo(() => {
    //     const sourceOptions = disablebut && metadata.length > 0 ? metadata : observationOptionsApi;

    //     return (observationSelected || []).reduce((sum, item) => {
    //         // якщо item вже нормальний object з pct
    //         if (item && typeof item === "object" && item.pct != null) {
    //             return sum + (Number(item.pct) || 0);
    //         }

    //         // якщо item це string / key / value
    //         const rawValue =
    //             typeof item === "string"
    //                 ? item
    //                 : item?.value ?? item?.key ?? null;

    //         if (!rawValue) return sum;

    //         const found = (sourceOptions || []).find(
    //             (opt) => opt.value === rawValue || opt.key === rawValue
    //         );

    //         return sum + (Number(found?.pct) || 0);
    //     }, 0);
    // }, [observationSelected, metadata, observationOptionsApi, disablebut]);



        useLayoutEffect(() => {
            if (obsMenuOpen && menuListElRef.current) {
                // повертаємо скрол після перерендеру
                menuListElRef.current.scrollTop = menuScrollTopRef.current || 0;
            }
        }, [observationSelected, obsMenuOpen]);


    // ✅ дефолт завжди 0.5 / 0.5
    // const DEFAULT_T = 0.5;
    // const [lower, setLower] = useState(DEFAULT_T);
    // const [upper, setUpper] = useState(DEFAULT_T);
    const [selectedRow, setSelectedRow] = useState(null);

    const DEFAULT_T = 0.5;

    const initialGeneralThresholds = normalizeThresholdPair(
    GlobalState.activemodel?.lastTrain?.lowerThreshold,
    GlobalState.activemodel?.lastTrain?.upperThreshold,
    DEFAULT_T
    );

    const [lower, setLower] = useState(initialGeneralThresholds.lower);
    const [upper, setUpper] = useState(initialGeneralThresholds.upper);

    // const modelId = GlobalState.activemodel?.id || activemodel?.id;
    // const cookieKey = modelId ? `${THRESH_COOKIE_PREFIX}${modelId}` : null;

    const doubleThresholdsData =
        GlobalState.activemodel?.lastTrain?.metadata?.doubleThresholdsData || [];

    const selectedThresholdObj = useMemo(() => {
        return doubleThresholdsData.find(
        (o) =>
            sameStep(o.lowerThreshold, lower) &&
            sameStep(o.upperThreshold, upper)
        );
    }, [doubleThresholdsData, lower, upper]);
    
    const handleThresholdChange = (newLower, newUpper) => {
        setLower(newLower);
        setUpper(newUpper);
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(255, 255, 255, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: 'calc(100% - 20px)',
            height: '38px',
            color: 'rgba(2, 2, 3, 1)',
            border: '1px solid rgba(255, 255, 255, 1)',
            boxShadow: 'none',
            fontSize: 16,
            '&:hover': {
                border: '1px solid rgba(245, 197, 56, 1)',
            },
        }),
        input: (provided) => ({
            ...provided,
            color: 'rgba(2, 2, 3, 1)',
        }),
        
        menu: (provided) => ({
            ...provided,
            background: 'rgba(255, 255, 255, 1)',
            width: 'calc(100% - 20px)',
            marginTop: '0px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(2, 2, 3, 0.6)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 16,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(2, 2, 3, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(255, 255, 255, 0)', 
            },
            '&:active': {
                backgroundColor: 'rgba(255, 255, 255, 0)', 
            }
            }),
    };

    const DropdownIndicator = props => {
        return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {
                props.selectProps.menuIsOpen ? 
                    
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6.8451" cy="9.46229" r="1.53846" fill="#020203"/>
                        <circle cx="6.8451" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                        <circle cx="6.8451" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                        <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="#020203"/>
                        <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" strokeOpacity="0.2"/>
                        <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" strokeOpacity="0.2"/>
                    </svg>
                    : 
                    !disablebut?
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30786 3.3584)" fill="#020203"/>
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30786 3.3584)" fill="black" fillOpacity="0.2"/>
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30786 3.3584)" fill="black" fillOpacity="0.2"/>
                        <path d="M0.692383 4.1274L7.03271 10.2812L13.0001 4.1274" stroke="#020203"/>
                        <path d="M0.692383 4.1274L7.03271 10.2812L13.0001 4.1274" stroke="black" strokeOpacity="0.2"/>
                        <path d="M0.692383 4.1274L7.03271 10.2812L13.0001 4.1274" stroke="black" strokeOpacity="0.2"/>
                    </svg>
                    :
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.2">
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30664 3.07617)" fill="#8E8E93"/>
                        <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="#8E8E93"/>
                        </g>
                    </svg>

                }
            </components.DropdownIndicator>
        )
        );
    };
    // --- Multiselect with checkboxes (react-select) ---
    const ObsOption = (props) => {
        const { isSelected, label } = props;

        return (
            <components.Option {...props}>
            <div className="himciObsMs__optRow">
                {isSelected ? 
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="3" width="14" height="14" rx="2" fill="white"/>
                    <path d="M5.20833 2.5C4.49004 2.5 3.80116 2.78534 3.29325 3.29325C2.78534 3.80116 2.5 4.49004 2.5 5.20833V14.7917C2.5 15.51 2.78534 16.1988 3.29325 16.7067C3.80116 17.2147 4.49004 17.5 5.20833 17.5H14.7917C15.51 17.5 16.1988 17.2147 16.7067 16.7067C17.2147 16.1988 17.5 15.51 17.5 14.7917V5.20833C17.5 4.49004 17.2147 3.80116 16.7067 3.29325C16.1988 2.78534 15.51 2.5 14.7917 2.5H5.20833ZM3.75 5.20833C3.75 4.40333 4.40333 3.75 5.20833 3.75H14.7917C15.5967 3.75 16.25 4.40333 16.25 5.20833V14.7917C16.25 15.1784 16.0964 15.5494 15.8229 15.8229C15.5494 16.0964 15.1784 16.25 14.7917 16.25H5.20833C4.82156 16.25 4.45063 16.0964 4.17714 15.8229C3.90365 15.5494 3.75 15.1784 3.75 14.7917V5.20833ZM14.4 7.73333C14.4614 7.67611 14.5107 7.60711 14.5448 7.53045C14.579 7.45378 14.5973 7.37102 14.5988 7.2871C14.6003 7.20318 14.5849 7.11983 14.5534 7.042C14.522 6.96418 14.4752 6.89348 14.4159 6.83414C14.3565 6.77479 14.2858 6.728 14.208 6.69656C14.1302 6.66513 14.0468 6.64969 13.9629 6.65117C13.879 6.65265 13.7962 6.67102 13.7196 6.70518C13.6429 6.73934 13.5739 6.78859 13.5167 6.85L8.33083 12.03L6.48333 10.1833C6.36485 10.0729 6.20815 10.0128 6.04623 10.0157C5.88431 10.0185 5.72983 10.0841 5.61531 10.1986C5.5008 10.3132 5.43521 10.4676 5.43235 10.6296C5.4295 10.7915 5.4896 10.9482 5.6 11.0667L7.8875 13.355C8.00469 13.472 8.16354 13.5378 8.32917 13.5378C8.49479 13.5378 8.65365 13.472 8.77083 13.355L14.4 7.73333Z" fill="#34C759"/>
                </svg>
                : 
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3.00195" y="3.00098" width="14" height="14" rx="2" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23875 3.33301H14.7626C15.2677 3.33301 15.7522 3.53369 16.1094 3.8909C16.4666 4.24811 16.6673 4.7326 16.6673 5.23777V14.7616C16.6673 15.2668 16.4666 15.7512 16.1094 16.1084C15.7522 16.4657 15.2677 16.6663 14.7626 16.6663H5.23875C4.73357 16.6663 4.24909 16.4657 3.89188 16.1084C3.53466 15.7512 3.33398 15.2668 3.33398 14.7616V5.23777C3.33398 4.7326 3.53466 4.24811 3.89188 3.8909C4.24909 3.53369 4.73357 3.33301 5.23875 3.33301Z" stroke="#C7C7CC" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                }
                <span className="himciObsMs__optLabel">{label}</span>
            </div>
            </components.Option>
        );
    };

    const obsMultiStyles = {
        control: (provided, state) => ({
        ...provided,
        background: "rgba(255, 255, 255, 1)",
        width: "calc(100% - 20px)",
        minHeight: "38px",
      
        border: state.menuIsOpen
            ? "1px solid rgba(245, 197, 56, 1)"
            : "1px solid rgba(255, 255, 255, 1)",
        borderBottom: '0px',
        borderRadius: 8,
        boxShadow: "none",   // 🔥 прибрали синій outline
        outline: "none",
        borderBottomLeftRadius: state.menuIsOpen? 0: 8, borderBottomRightRadius: state.menuIsOpen? 0: 8,    
        cursor: "pointer",
        
        "&:hover": { border: state.menuIsOpen? "1px solid rgba(245, 197, 56, 1)": "1px solid rgb(255, 255, 255)", borderBottom: '0px', borderBottomLeftRadius: state.menuIsOpen? 0: 8, borderBottomRightRadius: state.menuIsOpen? 0: 8, },
        }),
        valueContainer: (provided) => ({
        ...provided,
        paddingLeft: 10,
        paddingRight: 10,
         paddingTop: 0,
            paddingBottom: 0,
            
            position: 'relative',
            top: '-2px'
        }),
        menu: (provided) => ({
        ...provided,
        width: "calc(100% - 20px)",
        marginTop: 0,
        boxShadow: "none",
        border: "1px solid rgba(245, 197, 56, 1)",
        borderTop: 0,
        borderRadius: 8,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        }),
        menuList: (provided) => ({
        ...provided,
        maxHeight: 220, // внутрішній скрол
        paddingTop: 0,
        paddingBottom: 6,
        }),
        option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "rgba(255, 255, 255, 1)" : "transparent", // зелене для вибраних
        color: "rgba(2, 2, 3, 0.6)",
        fontSize: '12px',
        cursor: "pointer",
        "&:hover": { backgroundColor: "rgba(245, 247, 251, 1)" },
        }),
        multiValue: (provided) => ({
        ...provided,
        backgroundColor: "rgba(244, 245, 247, 1)",
        borderRadius: 999,
        }),
        multiValueLabel: (provided) => ({
        ...provided,
        fontSize: 13,
        color: "rgba(2, 2, 3, 1)",
        }),
        multiValueRemove: (provided) => ({
        ...provided,
        cursor: "pointer",
        ":hover": { backgroundColor: "transparent", color: "rgba(2, 2, 3, 1)" },
        }),
    };

    const ObsMenuList = (props) => {
        const { options, selectProps } = props;
        const totalCount = options?.length ?? 0;

        const onSelectAll = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const all = options; // це масив option-ів {value,label,pct}
            selectProps.onChange(all, { action: "select-option" });
        };

        const onReset = (e) => {
            e.preventDefault();
            e.stopPropagation();
            selectProps.onChange([], { action: "clear" });
        };

        return (
            <components.MenuList {...props}>
            <div
                className="himciObsMs__menuTop"
                onMouseDown={(e) => {
                // не даємо меню закритись / втратити фокус
                e.preventDefault();
                e.stopPropagation();
                }}
            >
                <button
                type="button"
                className="himciObsMs__menuBtn"
                onMouseDown={onSelectAll}
                >
                Select all ({totalCount})
                </button>

                <span className="himciObsMs__menuSep">-</span>

                <button
                type="button"
                className="himciObsMs__menuBtn himciObsMs__menuBtn--muted"
                onMouseDown={onReset}
                >
                Reset
                </button>
            </div>

            {/* сам список опцій */}
            {props.children}
            </components.MenuList>
        );
        };



    const changecategorytarget = useCallback((val) => {
        const selectedDataset = (GlobalState.dataset || []).find(
            (n) => n.id === val || String(n.id) === String(val)
        );

        const nextOptions = Object.values(selectedDataset?.columnNames || {}).map((value) => ({
            value,
            label: value,
        }));

        setOptiontarget(val);
        setTargetDataset(val);
        setOptionfields(nextOptions);
        setOptiontargetfields("");
        setIsTargetDatasetChanged(true);
    }, []);
    const formatDate = useCallback((dateString) => {
        return normalizeDateLike(dateString).display;
    }, []);
    const formatObservationDate = useCallback((dateString) => {
        return normalizeDateLike(dateString).display;
    }, []);

    const [textloading, setTextloading] = useState(langv?.open_model?.text1);
    const [textloadingSeg, setTextloadingSeg] = useState("Loading");
    const [textloadingcompleated, setTextloadingcompleated] = useState(langv?.open_model?.text2);
    const [textfaildetaile, setTextfaildetaile] = useState(langv?.open_model?.text2);
    
    
    const addmodel = () => {
        if (
            GlobalState.activemodel?.lastTrain?.deploymentState === "done" ||
            GlobalState.activemodel?.lastTrain?.deploymentState === "in_progress"
        ) {
            return;
        }

        changeActiveThreshold(lower, upper);
        changepopupaddAttachmentAnalitics(0);
    };

    useEffect(() => {
        var op = [];
        GlobalState.dataset.map((n, id)=>{
            n.id==GlobalState.activemodel?.lastTrain?.targetDataset?
            Object.entries(n?.columnNames).map(([key, value])=>{
                op = [...op, { value: value, label: value}]
            })
            :
            <></>
        })
        setOptionfields(op);

       
    }, [])

    useEffect(() => {
        if (load === 1) return; // не чіпай, якщо зараз показуємо лоадер відкриття
        if (GlobalState.activemodel?.lastTrain?.state === "in_progress") setLoad(1);
        // else setLoad(3);
    }, [GlobalState.activemodel?.lastTrain?.state, GlobalState.activemodel?.lastTrain?.metadata?.metrics]);

    useEffect(() => {
        segments.length==1?
            setActivetab(0)
            :
            <></>
        
    }, [segments]);
    
    useEffect(() => {
       
        var op2 = [];
       
        const period = GlobalState.activemodel?.lastTrain?.additionalTestingPeriod ?? {};

        op2 = Object.entries(period).map(([key, value]) => {
            const normalized = normalizeDateLike(key);

            return {
                value: key,              // raw key
                rawValue: key,           // raw key
                normalizedKey: normalized.key,
                key: normalized.key,     // службовий ключ для match/sort
                label: `${normalized.display} (${Number(value).toFixed(2)} %)`,
                pct: Number(value) || 0,
            };
        });
           
        setMetadata(op2);
        op2.length>0?setIsAdditionalTesting(true):setIsAdditionalTesting(false)
        console.log("secu" + JSON.stringify(op2) );
        
    }, [GlobalState.activemodel?.lastTrain])
  

    // async function getModel(activemodel)
    // {
        
    //     var token = localStorage.getItem("token");
    //     localStorage.setItem("countactivetime", Date.now());
    //     const response = await fetch(Domen.url + `model/`+activemodel, {
    //         method: 'GET',
    //         headers: {
    //             'Authorization': token,
    //             'Content-Type': 'application/json',
    //         }
    //     })
    //     if(response.status=="200")
    //     {
    //         const data = await response.json();
           
    //         if(data.lastTrain.state=="done"&&data.lastTrain?.metadata?.length>0)
    //         {
    //             changeActiveModel(data);
                
    //             setTimeout(function(){
    //                 setLoad(3);
    //             }, 2000)

                 
    //         }
    //         else if(data.lastTrain.state=="failed")
    //         {
    //             changeActiveModel(data);
                
    //             setTimeout(function(){
    //                 setLoad(4);
    //             }, 2000)
    //              console.log("secu3" + JSON.stringify(data) );
    //         }
    //         else{
    //             changeActiveModel(data);
    //             setTimeout(function(){
    //                 getModel(activemodel)
    //             }, 30000)
    //             console.log("secu2" + JSON.stringify(data?.lastTrain) );
    //         }
            
    //     }
    // } 

    async function getModel(activemodel)
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model/`+GlobalState.activemodel?.id, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            console.log('loadtest')
            if(data.lastTrain.state=="done")
            {
                changeActiveModel(data);
            }
            else
            {
                // setTextfaildetaile(data.lastTrain.errors?.[0]?.message||"test");
                // setLoad(99);
                
            }

        }

    } 

    async function getModelRetrein(activemodel)
    {
    
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model/`+activemodel, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            
            if(data.lastTrain.state=="done")
            {
                changeActiveModel(data);
                setLoad(3);
            }
            else if(data.lastTrain.state=="in_progress")
            {
                setTimeout(() => getModelRetrein(activemodel), 10000)
            }
            else if(data.lastTrain.state=="initial")
            {
                setTimeout(() => getModelRetrein(activemodel), 10000)
            }
            else{
                setLoad(44);
            }
           
            
        }
       
    } 

    async function getMetrix(id)
    { 
        setLoad(1)
        if (id.includes("test"))
        { 
            setActiveSegmentMeta(null);

            changeActiveModelLastTrain(
                GlobalState.activemodel?.lastTrain?.metadata || null
            );

            setLoad(3);
        }
        else{
            setLoad(1);
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            const response = await fetch(Domen.url + `model/`+GlobalState.activemodel?.id+'/metrics/'+id, {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                if (data.state == "finished") {
                    setActiveSegmentMeta(data?.segmentConditions || null);

                    const next = normalizeThresholdPair(
                        data?.lastTrain?.lowerThreshold,
                        data?.lastTrain?.upperThreshold,
                        DEFAULT_T
                    );

                    setLower(next.lower);
                    setUpper(next.upper);
                    changeActiveThreshold(next.lower, next.upper);
                    changeActiveSegmentThreshold(id);
                    changeActiveModelLastTrain(data.lastTrain.metadata);

                    setTimeout(function () {
                        setLoad(3);
                    }, 1000);
                }
                else if(data.state=="done")
                {
                     setLoad(3);
                }
                else if(data.state=="in_progress")
                {
                    setTimeout(() => getMetrix(id), 10000)
                }
                else if(data.state=="initial")
                {
                    setTimeout(() => getMetrix(id), 10000)
                }
                else{
                     setLoad(77);
                }
                 
                
            }
            else
            {
                setLoad(4)
                const user = Pool.getCurrentUser();
                user.getSession((err, session) => {
                    if (err) {
                        console.error("Error fetching user session:", err);                       
                    } 
                    else 
                    {
                        if (!session) {
                            console.log("No session found");
                            return;
                        }
                        else
                        {
                            const refreshToken  = session.getRefreshToken();
                            user.refreshSession(refreshToken, (err, result) => {
                                const { accessToken } = result;
                                localStorage.setItem("token", accessToken.jwtToken);
                                // getModels();
                            });
                        }
                        
                    }
                })
            }
        }
    } 
    console.log(activemodel||"test")
    async function updateSegmentName(segmentId, newName) {
        // тільки для бекенд-сегментів
        if (segmentId.includes("test")) {}
        else{

            const token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());

            const response = await fetch(
                Domen.url + `model/` + GlobalState.activemodel?.id + `/metrics/` + segmentId+`/rename`,
                {
                method: "PUT",
                headers: {
                    Authorization: token,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: newName }),
                }
            );

            if (!(response.status === 200 || response.status === 202 || response.status === "200" || response.status === "202")) {
                alert("Rename failed, status: " + response.status);
            }
        }
    }

    const retrain = async () =>{
        setObservationSelected([]);
        setObservationError(false);
        setMetadata([]);
        // setObservationOptionsApi([]);
        // setObsMenuOpen(false);
        if(GlobalState.activemodel?.lastTrain?.deploymentState=='done'||GlobalState.activemodel?.lastTrain?.deploymentState=='in_progress')
        {

        }
        else
        {
            metadata.length>0?setIsAdditionalTesting(true):setIsAdditionalTesting(false)
                                              
                                              
            setDisablebut(false)
            setLoad(0);
        }
    }

    const startmodel = async()=>{
        const selectedSnapshot = [...observationSelected];
        setLoad(1);
        setDisablebut(true);
        const getUseGpu = () => {
            const username = Pool.getCurrentUser()?.username;
            return username === "admin";
        };
        var token = localStorage.getItem("token");
        const additionalTestingPeriod = selectedSnapshot.reduce((acc, item) => {
            const rawKey = item?.rawValue ?? item?.value;
            if (!rawKey) return acc;

            acc[rawKey] = Number(item?.pct) || 0;
            return acc;
        }, {});
        var model = {
            featureDataset: optionmetrics||GlobalState.activemodel?.lastTrain?.featureDataset,
            targetDataset: optiontarget||GlobalState.activemodel?.lastTrain?.targetDataset,
            targetColumnName: optiontargetfields||GlobalState.activemodel?.lastTrain?.targetColumnName,
            learningType: optiontype||GlobalState.activemodel?.lastTrain?.learningType,
            learningCyclesCount: countmodal||GlobalState.activemodel?.lastTrain?.learningCyclesCount,
            additionalTestingPeriod:additionalTestingPeriod,
            useGpu: getUseGpu()
        };

        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model/`+ GlobalState.activemodel?.id + `/train`, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(model),
        })
        if(response.status=="200")
        {
            const data = await response.json();
            getModelRetrein(data?.id);
            setActivetab(0);
        }
        else{
            setLoad(4);
        }
    }

    const setAddmodel0 = ()=>{
        window.location.href='/analytics'
    }

    // ✅ LOAD from cookie (дозволяємо рівність; якщо навпаки — swap)
    // useEffect(() => {
    //     if (!cookieKey) return;

    //     const raw = getCookie(cookieKey);
    //     if (!raw) return;

    //     try {
    //         const parsed = JSON.parse(raw);
    //         const savedLower = safeClamp01(parsed?.lower);
    //         const savedUpper = safeClamp01(parsed?.upper);

    //         if (savedLower == null || savedUpper == null) return;

    //         let L = roundToStep(savedLower, STEP);
    //         let U = roundToStep(savedUpper, STEP);

    //         // якщо збережено навпаки — міняємо місцями
    //         if (L > U) [L, U] = [U, L];

    //         // ✅ НЕ відкидаємо рівність (0.5/0.5 — ок)
    //         setLower(L);
    //         setUpper(U);
    //     } catch (e) {
    //         // якщо cookie зламана/не JSON — просто ігноруємо
    //     }
    // }, [cookieKey]);

    function convertConditions(input) {
        const conditionsRaw = Array.isArray(input) ? input : input?.conditions;
        if (!Array.isArray(conditionsRaw)) return [];

        const result = [];

       const normalizeValue = (raw) => {
            // multiselect: [{ check, name }, ...]
            if (Array.isArray(raw)) {
                return raw
                .filter((v) => v && typeof v === "object" && v.check === true && v.name != null)
                .map((v) => String(v.name));
            }

            // single object на всяк випадок
            if (raw && typeof raw === "object") {
                if (raw.name != null) return String(raw.name);
                return "";
            }

            // input: "1", 1, etc.
            return raw != null ? String(raw) : "";
        };

        conditionsRaw.forEach(group => {
            const list = Array.isArray(group?.list) ? group.list : [];

            list.forEach(item => {
            const column = item?.activColumn;
            const operators = Array.isArray(item?.operator) ? item.operator : [];

            if (!column) return;

            operators.forEach(op => {
                if (!op?.operator) return;

                result.push({
                column: String(column),
                operator: op.operator,
                value: normalizeValue(op.value),
                });
            });
            });
        });

        return result;
        }

    // ✅ SAVE to cookie (нормалізуємо порядок + debounce)
    // useEffect(() => {
    //     if (!cookieKey) return;

    //     const t = setTimeout(() => {
    //         let L = roundToStep(lower, STEP);
    //         let U = roundToStep(upper, STEP);
    //         if (L > U) [L, U] = [U, L];

    //         const payload = JSON.stringify({ lower: L, upper: U });
    //         setCookie(cookieKey, payload, 365);
    //     }, 150); // debounce

    //     return () => clearTimeout(t);
    //     }, [cookieKey, lower, upper]);
    
        const AddSegment = async(data, datasetType)=>{
            
            var token = localStorage.getItem("token");
            var rules = [];
            var l = [];
            var l2 = [];
            console.log(JSON.stringify(data) + "  -");
            const flat = convertConditions(data); 
            var attr = {
                name: segments.find(s => s.id === activetab)?.name,
                testingSegment: datasetType,
                conditions: flat
            };
            localStorage.setItem("countactivetime", Date.now());
            const response = await fetch(Domen.url + `model/`+activemodel.id+`/metrics`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(attr),
            })
            if(response.status=="200"||response.status=="202")
            {
                const data = await response.json();
                getMetrix(data.id);
                setActivetab(data.id);
                getModel(activemodel.id);
            }
            else
            {
                alert("Something went wrong, request status:" + response.status)
            }
       
    }

        const handleEdit = ({ segmentName, modelId, activeDataset, rules, elseval, inputNameColumn, datasetType }) => {
            console.log("отримав дані з блоку", rules);
            AddSegment(rules, datasetType)
            setselectsOp(true)
        };

        const obsSelectComponents = useMemo(() => ({
                DropdownIndicator,
                Option: ObsOption,
                MenuList: ObsMenuList,
            }), []); // важливо: порожні deps
        const changecategorymetrix = useCallback((val) => {
            setOptionmetrics(val);
            setFeatureDataset(val);
        }, []);
        const fetchMetadata = useCallback(async (featureId, targetId) => {
            setObsLoading(true);
            try {
                const token = localStorage.getItem("token");
                localStorage.setItem("countactivetime", Date.now());
                
                const response = await fetch(
                `${Domen.url}model/dateDistribution?feature_dataset_id=${featureId}&target_dataset_id=${targetId}`,
                {
                    method: "GET",
                    headers: {
                    Authorization: token,
                    "Content-Type": "application/json",
                    },
                }
                );

                if (!response.ok) {
                console.error("Request failed:", response.status);
                return;
                }

                const data = await response.json();
            

                const grouped = {};

                Object.entries(data || {}).forEach(([rawKey, pct]) => {
                    const normalized = normalizeDateLike(rawKey);
                    const numericPct = Number(pct) || 0;

                    if (!normalized.key || numericPct <= 0) return;

                    if (!grouped[normalized.key]) {
                        grouped[normalized.key] = {
                            normalizedKey: normalized.key,
                            display: normalized.display,
                            pct: 0,
                            rawItems: [],
                        };
                    }

                    grouped[normalized.key].pct += numericPct;
                    grouped[normalized.key].rawItems.push({
                        rawKey,
                        pct: numericPct,
                    });
                });

                const nextOptions = Object.values(grouped)
                    .sort((a, b) => a.normalizedKey.localeCompare(b.normalizedKey))
                    .map((item) => ({
                        value: item.rawItems[0]?.rawKey ?? item.normalizedKey,
                        rawValue: item.rawItems[0]?.rawKey ?? item.normalizedKey,
                        normalizedKey: item.normalizedKey,
                        key: item.normalizedKey,
                        label: `${item.display} (${Number(item.pct.toFixed(2))} %)`,
                        pct: Number(item.pct.toFixed(2)),
                        rawItems: item.rawItems,
                    }));

                setObservationOptionsApi(nextOptions);
                //setObservationSelected([]);
            } catch (err) {
              
                setObservationSelected([]);
            }
            finally {
                setObsLoading(false); 
            }
        }, []);
        const buildMergedMetadata = (data) => {
            if (!data) return [];

            const { feature = [], target = [] } = data;

            return feature.map((f) => {
                const t = target.find((x) => x.name === f.name);

                return {
                    ...f,
                    target: t || null,
                };
            });
        };
        useEffect(() => {
            if (featureDataset && targetDataset) {
                fetchMetadata(featureDataset, targetDataset);
            }
        }, [featureDataset, targetDataset]);
        useEffect(() => {
            if (activetab !== 0) return;

            const next = normalizeThresholdPair(
                GlobalState.activemodel?.lastTrain?.lowerThreshold,
                GlobalState.activemodel?.lastTrain?.upperThreshold,
                DEFAULT_T
            );

            setLower(next.lower);
            setUpper(next.upper);
            changeActiveThreshold(next.lower, next.upper);
            changeActiveSegmentThreshold(0);
            }, [
            activetab,
            GlobalState.activemodel?.lastTrain?.lowerThreshold,
            GlobalState.activemodel?.lastTrain?.upperThreshold,
            ]);
        useEffect(() => {
            setFeatureDataset(GlobalState.activemodel?.lastTrain?.featureDataset ?? null);
            setTargetDataset(GlobalState.activemodel?.lastTrain?.targetDataset ?? null);
            }, [
            GlobalState.activemodel?.lastTrain?.featureDataset,
            GlobalState.activemodel?.lastTrain?.targetDataset,
        ]);
        const saveThreshold = async (lo, hi, metricId = null) => {
            setObsLoading(true);
            try {
                const token = localStorage.getItem("token");
            
                localStorage.setItem("countactivetime", Date.now());

                const model = {
                    upperThreshold: hi,
                    lowerThreshold: lo,
                };

                const url =
                    metricId && activetab !== 0
                        ? `${Domen.url}model/${GlobalState.activemodel?.id}/metrics/${metricId}/threshold`
                        : `${Domen.url}model/${GlobalState.activemodel?.id}/threshold`;

                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        Authorization: token,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(model),
                });

                if (!(response.status == 200 || response.status == 202)) {
                    console.error("saveThreshold failed:", response.status);
                }
            } catch (error) {
                console.error("saveThreshold error:", error);
            } finally {
                setObsLoading(false); 
            }
        };
    const GENERAL_TAB_ID = 0;
    const activeSegment = segments.find((seg) => seg.id === activetab) || null;

    useEffect(() => {
        if (disablebut && metadata.length > 0 && observationSelected.length === 0) {
            setObservationSelected(metadata);
        }
    }, [metadata, disablebut, observationSelected.length]);

    const sourceOptions = disablebut && metadata.length > 0 ? metadata : observationOptionsApi;

    const observationTotal = useMemo(() => {
        return calcObservationTotal(observationSelected, sourceOptions);
    }, [observationSelected, sourceOptions]);
    const isObservationOverLimit = isAdditionalTesting && observationTotal > 30;

    useEffect(() => {
        if (!Array.isArray(observationOptionsApi) || observationOptionsApi.length === 0) return;

        setObservationSelected((prev) => {
            if (!Array.isArray(prev) || prev.length === 0) return prev;

            return prev
                .map((item) => {
                    const normalizedKey = normalizeDateLike(item?.value ?? item).key;
                    return observationOptionsApi.find((opt) => opt.value === normalizedKey);
                })
                .filter(Boolean);
        });
    }, [observationOptionsApi]);
    
    return (
        <div className='addmodel_block'>
            <div className='addmodel_head'>
                <div className='addmodel_head_tabs'>
                    <div className='addmodel_head_tab active'>
                        
                    {langv?.open_model?.text16}: {GlobalState.activemodel.modelName}
                    </div>
                </div>
               
                <div className='controler_top'> 
                    <div className='betta'>
                        <div className='betta_inside'>
                        {langv?.beta?.head_text}
                        </div>
                    </div>
                   
                    <div className='buttons_line_v'>
                        <div className={(GlobalState.activemodel?.lastTrain?.deploymentState=='done'||GlobalState.activemodel?.lastTrain?.deploymentState=='in_progress')||obsLoading||load==1||load==4||load==0?'button_retrain inactive':'button_retrain'} onClick={()=>!obsLoading&&load!=1&&load!=4&&load!=99&&load!=0  && retrain()}>
                            <svg className='nonactive' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.15">
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="#020203"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="black" fillOpacity="0.2"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="black" fillOpacity="0.2"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.1761 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" stroke="white" strokeWidth="0.5"/>
                                </g>
                            </svg>
                            <svg className='def_icon' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="#020203"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="black" fillOpacity="0.2"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="black" fillOpacity="0.2"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" stroke="white" strokeWidth="0.5"/>
                                </g>
                            </svg>
                            <svg className='hov_icon' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="#020203"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="black" fillOpacity="0.2"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" fill="black" fillOpacity="0.2"/>
                                <path d="M18.1761 5.82349L18.3541 6.0029L18.5316 5.82291L19.2509 5.0932C19.2512 5.09299 19.2514 5.09278 19.2516 5.09257C19.8033 4.54261 20.75 4.93632 20.75 5.71488V9.75267C20.75 10.2329 20.3555 10.6274 19.8738 10.6274H15.831C15.055 10.6274 14.665 9.68463 15.2193 9.131L16.9198 7.43265L17.0961 7.25657L16.9206 7.07969C15.661 5.81 13.9317 5.00374 11.9908 5.00374H11.9906C10.94 5.0047 9.90298 5.24154 8.95635 5.69677C8.00972 6.152 7.17764 6.81396 6.52167 7.63373C5.86571 8.45349 5.40265 9.41007 5.16676 10.4327C4.93099 11.4549 4.9282 12.5168 5.15859 13.5402C5.70862 16.1318 7.79801 18.2418 10.3927 18.8144C11.9585 19.1796 13.6025 18.9953 15.0483 18.2924C16.4939 17.5897 17.6533 16.4113 18.3315 14.9553C18.4661 14.6796 18.7668 14.5016 19.0968 14.5016C19.744 14.5016 20.1668 15.1737 19.8848 15.7634L19.8845 15.764C19.176 17.2558 18.0582 18.5162 16.6609 19.3988C15.2636 20.2815 13.6442 20.75 11.9908 20.75C6.81206 20.75 2.70644 16.2785 3.30884 10.9731L3.30888 10.9727C3.75746 6.96246 7.06495 3.70239 11.0811 3.298L11.0823 3.29789C12.3786 3.16142 13.6891 3.31753 14.9169 3.75468C16.1448 4.19183 17.2586 4.89884 18.1761 5.82349Z" stroke="white" strokeWidth="0.5"/>
                            </svg>
                            {langv?.open_model?.text14}
                        </div>
                        {
                            load!=4?
                        
                            <div className={(GlobalState.activemodel?.lastTrain?.deploymentState=='done'||GlobalState.activemodel?.lastTrain?.deploymentState=='in_progress')||obsLoading||load==1||load==4||load==0?'button_retrain inactive':'button_retrain'} onClick={()=>!obsLoading&&load!=1&&load!=4&&load!=99&&load!=0 && addmodel()}> 
                                <svg className='nonactive' width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.15">
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="#020203" strokeWidth="1.44"/>
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="black" strokeOpacity="0.2" strokeWidth="1.44"/>
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="black" strokeOpacity="0.2" strokeWidth="1.44"/>
                                    </g>
                                </svg>
                                <svg className='def_icon' width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.6">
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="#020203" strokeWidth="1.44"/>
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="black" strokeOpacity="0.2" strokeWidth="1.44"/>
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="black" strokeOpacity="0.2" strokeWidth="1.44"/>
                                    </g>
                                </svg>

                                <svg  className='hov_icon' width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="#020203" strokeWidth="1.44"/>
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="black" strokeOpacity="0.2" strokeWidth="1.44"/>
                                    <path d="M10.24 23.0799L16.48 12.9999H10.24V2.91992L4 12.9999H10.24V23.0799Z" stroke="black" strokeOpacity="0.2" strokeWidth="1.44"/>
                                </svg>
                                
                                {langv?.open_model?.text15}
                            </div>
                            :
                            <></>
                        }
                    </div>
                    <div className='addmodel_head_back' onClick={()=>setAddmodel0(false)}>
                    
                    <svg className='def_icon' width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#F5C538" stroke="#F5C538"/>
                            <path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" strokeLinecap="round"/>
                            <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            <path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" strokeLinecap="round"/>
                            <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                        </svg>
                        <svg className='hov_icon' width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#41A8B1" stroke="#41A8B1"/>
                            <path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" strokeLinecap="round"/>
                            <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            <path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            <path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" strokeLinecap="round"/>
                            <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                            <path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" strokeOpacity="0.2" strokeLinecap="round"/>
                        </svg>
                    </div>
                   
                </div>
            </div>
            <div className='addmodel_body '>
                
                <div className='addmodel_fields obs-wrapper'>
                    {obsLoading && <div className="obs-blur-overlay"><Loading text = {"Loading ..."}/></div>}
                    <div className='addmodel_fields_line'>
                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text24}</div>
                        <div className='icon_disable' onClick={()=>setDisabletitle(!disabletitle)}>
                        {
                                !disabletitle?
                               
                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.4">
                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                    </g>
                                </svg>
                                
                                :
                                
                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.4">
                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                    </g>
                                </svg>
                                
                            }
                        </div>
                    </div>
                    {

                        disabletitle?
                        <></>
                        :
                        <>
                        <div className='addmodel_fields_line' style={{marginTop: "24px", position: "relative", zIndex: "99999999"}}>
                            <div className='addmodel_fields_col'>
                                <label>{langv?.open_model?.text6}</label>
                                <input
                                    id="source"
                                    type="text"
                                    placeholder={langv?.open_model?.text7}
                                    className={disablebut?"tra1":"tra2 tra3"}
                                    value={namemodal}
                                    disabled={disablebut}
                                    onChange={(event) =>setNamemodal(event.target.value)}
                                />
                            </div>
                            <div className='addmodel_fields_col'>
                                <label>{langv?.open_model?.text8}</label>
                               
                                <Select 
                                    components={{ DropdownIndicator }}
                                    options={optionsstep} 
                                    styles={customStyles} 
                                    classNamePrefix='filter'
                                    className={disablebut?"selectproduct tra1 ":"selectproduct tra2"}
                                      
                                    isDisabled={disablebut}
                                    placeholder={<div className='selectplace active'>{GlobalState.activemodel?.lastTrain?.learningCyclesCount||langv?.open_model?.text9}</div>}
                                    onChange={(option) => setCountmodal(option.value)}
                                />
                            </div>
                            <div className='addmodel_fields_col' style={{position: "relative", zIndex: "999999999999999"}}>
                                <label>{langv?.open_model?.text10}</label>
                                <Select 
                                    components={{ DropdownIndicator }}
                                    options={optionstype} 
                                    styles={customStyles} 
                                    classNamePrefix='filter'
                                    className={disablebut?"selectproduct tra1 ":"selectproduct tra2"}
                                      
                                    isDisabled={disablebut}
                                    placeholder={<div className='selectplace active'>{GlobalState.activemodel?.lastTrain?.learningType}</div>}
                                    onChange={(option) => setOptiontype(option.value)}
                                />
                            </div>
                        </div>
                        <div className='addmodel_fields_line' style={{marginTop: "20px",  position:"relative", zIndex:"999999"}}>
                            <div className='addmodel_fields_col'>
                                <label>{langv?.open_model?.text11}</label>
                                <Select 
                                    components={{ DropdownIndicator }}
                                    options={options} 
                                    styles={customStyles} 
                                    classNamePrefix='filter'
                                    className={disablebut?"selectproduct tra1 ":"selectproduct tra2"}
                                      
                                    isDisabled={disablebut}
                                    placeholder={<div className='selectplace active'>{GlobalState.activemodel?.lastTrain?.featureDatasetName}</div>}
                                    onChange={(option) => changecategorymetrix(option.value)}
                                />
                            </div>
                            <div className='addmodel_fields_col'>
                                <label>{langv?.open_model?.text12}</label>
                                <Select 
                                    components={{ DropdownIndicator }}
                                    options={options} 
                                    styles={customStyles}
                                    classNamePrefix='filter' 
                                    className={disablebut?"selectproduct tra1 ":"selectproduct tra2"}
                                      
                                    isDisabled={disablebut}
                                    placeholder={<div className='selectplace active'>{GlobalState.activemodel?.lastTrain?.targetDatasetName}</div>}
                                    onChange={(option) => changecategorytarget(option.value)}
                                />
                            </div>
                            <div className='addmodel_fields_col'>
                                <label>{langv?.open_model?.text13}</label>
                                <Select 
                                    components={{ DropdownIndicator }}
                                    options={optionfields} 
                                    styles={customStyles} 
                                    classNamePrefix='filter'
                                    className={disablebut?"selectproduct tra1 ":"selectproduct tra2"}
                                    value={
                                            optionfields.find((option) => option.value === optiontargetfields) || null
                                        }    
                                    isDisabled={disablebut}
                                    placeholder={
                                        <div className='selectplace active'>
                                            {
                                                isTargetDatasetChanged
                                                    ? langv?.add_model?.text14
                                                    : GlobalState.activemodel?.lastTrain?.targetColumnName
                                            }
                                        </div>
                                    }
                                    onChange={(option) => setOptiontargetfields(option.value)}
                                />
                            </div>
                        </div>


                        <div className='addmodel_fields_line align_items_fe' style={{marginTop: "20px"}}>
                            <div className='addmodel_fields_col'>
                                <div className='addition'>
                                    Additional testing period
                                    <div className='click_tooltipe'>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.003033 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM7 12.8333C5.84628 12.8333 4.71846 12.4912 3.75918 11.8502C2.79989 11.2093 2.05222 10.2982 1.61071 9.23232C1.16919 8.16642 1.05368 6.99353 1.27876 5.86197C1.50384 4.73042 2.05941 3.69102 2.87521 2.87521C3.69102 2.0594 4.73042 1.50383 5.86198 1.27875C6.99353 1.05367 8.16642 1.16919 9.23232 1.6107C10.2982 2.05221 11.2093 2.79989 11.8502 3.75917C12.4912 4.71846 12.8333 5.84627 12.8333 7C12.8333 8.54709 12.2188 10.0308 11.1248 11.1248C10.0308 12.2187 8.5471 12.8333 7 12.8333Z" fill="#8E8E93"/>
                                            <path d="M6.99832 5.65761C6.84361 5.65761 6.69524 5.71907 6.58585 5.82847C6.47645 5.93786 6.41499 6.08624 6.41499 6.24095V10.2076C6.41499 10.3623 6.47645 10.5107 6.58585 10.6201C6.69524 10.7295 6.84361 10.7909 6.99832 10.7909C7.15303 10.7909 7.30141 10.7295 7.4108 10.6201C7.5202 10.5107 7.58166 10.3623 7.58166 10.2076V6.24095C7.58166 6.08624 7.5202 5.93786 7.4108 5.82847C7.30141 5.71907 7.15303 5.65761 6.99832 5.65761ZM6.99832 3.26595C6.84041 3.27188 6.69076 3.33806 6.5801 3.45088C6.46945 3.5637 6.40619 3.71461 6.40332 3.87261V3.96595C6.40305 4.04206 6.41862 4.11739 6.44905 4.18715C6.47947 4.25691 6.52409 4.31958 6.58006 4.37116C6.63603 4.42274 6.70212 4.4621 6.77413 4.48674C6.84614 4.51138 6.92249 4.52076 6.99832 4.51428C7.15119 4.50851 7.29623 4.44519 7.4044 4.33702C7.51257 4.22885 7.57588 4.08381 7.58166 3.93095V3.79095C7.58212 3.71681 7.56687 3.64341 7.53691 3.57559C7.50696 3.50777 7.46298 3.44706 7.40787 3.39747C7.35277 3.34787 7.28778 3.31051 7.21719 3.28784C7.1466 3.26517 7.07201 3.25771 6.99832 3.26595Z" fill="#8E8E93"/>
                                        </svg>
                                        <div className='tooltipe'>
                                            By default, 80% of the records are used for training and 20% for testing the model. The additional testing period will also not be included in training.
                                        </div>
                                    </div>
                                    
                                    {
                                        disablebut?
                                        <label class="switch disable">
                                            {
                                                metadata.length>0?
                                            
                                                <input type="checkbox" checked="true"/>
                                                :
                                                <input
                                                    type="checkbox"
                                                    checked={isAdditionalTesting}
                                                    disabled
                                                    readOnly
                                                />
                                            
                                            }
                                            
                                            <span class="slider_sw"></span>
                                        </label>
                                        :
                                        <label class="switch">
                                               
                                                <input type="checkbox" checked={isAdditionalTesting} onChange={(e) => setIsAdditionalTesting(e.target.checked)}/>
                                              
                                            
                                            <span class="slider_sw"></span>
                                        </label>
                                    }
                                    

                                    
                                </div>
                            </div>
                            {/* {
                                isAdditionalTesting?
                                    disablebut?
                                        metadata.length>0?
                                    
                                        <div className='addmodel_fields_col addmodel_fields_col_2'>
                                            <label style={{ marginTop: "6px" }}>Total: {observationTotal}%</label>
                                            {
                                                <Select
                                                    components={obsSelectComponents}
                                                    isMulti
                                                    // menuIsOpen={true}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    options={metadata}
                                                    value={observationSelected}
                                                    onMenuOpen={() => setObsMenuOpen(true)}
                                                    onMenuClose={() => setObsMenuOpen(false)}
                                                    onChange={(vals) => {
                                                        const next = vals || [];
                                                        const total = next.reduce((sum, o) => sum + (o?.pct || 0), 0);
                                                        if (total > 30) {
                                                            setObservationError(true);
                                                            return;
                                                        }
                                                        setObservationError(false);
                                                        setObservationSelected(next);
                                                    }}
                                                    styles={obsMultiStyles}
                                                    classNamePrefix="himciObsMs"
                                                    menuShouldScrollIntoView={false}
                                                    // className={disablebut ? "selectproduct tra1" : "selectproduct tra2"}
                                                     
                                                    isDisabled={false}
                                                    className={"selectproduct tra2"}
                                                    captureMenuScroll={false}
                                                    menuListElRef={menuListElRef}
                                                    menuScrollTopRef={menuScrollTopRef}
                                                    blurInputOnSelect={false}
                                                    placeholder={<div className="selectplace active">Select observation date</div>}
                                                />
                                            }
                                        </div>
                                        :
                                        <></>
                                        :
                                        <div className='addmodel_fields_col addmodel_fields_col_2'>
                                            
                                            <label style={{ marginTop: "6px" }}>Total: {observationTotal}%</label>
                                            {
                                                disablebut?
                                            
                                                <Select
                                                    components={{ DropdownIndicator, Option: ObsOption, MenuList: ObsMenuList, }}
                                                    isMulti
                                                    // menuIsOpen={true}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    options={metadata}
                                                    value={metadata}
                                                    onChange={(vals) => setObservationSelected(vals ? vals.map(v => v.key) : [])}
                                                    styles={obsMultiStyles}
                                                    classNamePrefix="himciObsMs"
                                                    // className={disablebut ? "selectproduct tra1" : "selectproduct tra2"}
                                                     
                                                    isDisabled={true}
                                                    className={"selectproduct tra2"}
                                                    placeholder={<div className="selectplace active">Select observation date</div>}
                                                />
                                                :
                                                <Select
                                                    components={obsSelectComponents}
                                                    isMulti
                                                    // menuIsOpen={true}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    options={metadata}
                                                    value={observationSelected}
                                                    onMenuOpen={() => setObsMenuOpen(true)}
                                                    onMenuClose={() => setObsMenuOpen(false)}
                                                    onChange={(vals) => {
                                                        const next = vals || [];
                                                        const total = next.reduce((sum, o) => sum + (o?.pct || 0), 0);
                                                        if (total > 30) {
                                                            setObservationError(true);
                                                            return;
                                                        }
                                                        setObservationError(false);
                                                        setObservationSelected(next);
                                                    }}
                                                    styles={obsMultiStyles}
                                                    classNamePrefix="himciObsMs"
                                                    menuShouldScrollIntoView={false}
                                                    // className={disablebut ? "selectproduct tra1" : "selectproduct tra2"}
                                                     
                                                    isDisabled={false}
                                                    className={"selectproduct tra2"}
                                                    captureMenuScroll={false}
                                                    menuListElRef={menuListElRef}
                                                    menuScrollTopRef={menuScrollTopRef}
                                                    blurInputOnSelect={false}
                                                    placeholder={<div className="selectplace active">Select observation date</div>}
                                                />
                                            }

                                        

                                        </div>
                                    :
                                    <></>
                            } */}
                            {
                                isAdditionalTesting?
                            
                                <div className='addmodel_fields_col addmodel_fields_col_2'>      
                                    <label style={{ marginTop: "6px" }}>Total: {Number(observationTotal).toFixed(2)}%</label>
                                    {
                                        disablebut?
                                    
                                        <Select
                                            components={{ DropdownIndicator, Option: ObsOption, MenuList: ObsMenuList }}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            options={metadata}
                                            value={observationSelected}
                                            styles={obsMultiStyles}
                                            classNamePrefix="himciObsMs"
                                             
                                            isDisabled={true}
                                            className={"selectproduct tra2"}
                                            placeholder={<div className="selectplace active">Select observation date</div>}
                                        />
                                        :
                                        <Select
                                            components={obsSelectComponents}
                                            isMulti
                                            // menuIsOpen={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            options={observationOptionsApi}
                                            value={observationSelected}
                                            onMenuOpen={() => setObsMenuOpen(true)}
                                            onMenuClose={() => setObsMenuOpen(false)}
                                            onChange={(vals) => {
                                                const next = vals || [];
                                                const total = next.reduce((sum, o) => sum + (o?.pct || 0), 0);
                                                setObservationSelected(next);
                                                setObservationError(total > 30);
                                            }}
                                            styles={obsMultiStyles}
                                            classNamePrefix="himciObsMs"
                                            menuShouldScrollIntoView={false}
                                            // className={disablebut ? "selectproduct tra1" : "selectproduct tra2"}
                                             
                                            isDisabled={false}
                                            className={"selectproduct tra2"}
                                            captureMenuScroll={false}
                                            menuListElRef={menuListElRef}
                                            menuScrollTopRef={menuScrollTopRef}
                                            blurInputOnSelect={false}
                                            placeholder={<div className="selectplace active">Select observation date</div>}
                                        />
                                        
                                    }
                                    {observationError && (
                                        <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "6px" }}>
                                            The total selection of dates for additional testing period must not exceed 30%.
                                        </div>
                                    )}
                                </div>
                                :
                                <></>
                            }
                        </div>
                        <div className='addmodel_fields_line' style={{marginBottom:"0px", marginTop: "20px"}}>
                           
                            {
                                load==0?
                                <>
                                    <div className='addmodel_fields_col'></div>
                                    <div className='addmodel_fields_col'>
                                        <div className='addmodel_button_line' >
                                            {
                                                !isObservationOverLimit && (!isTargetDatasetChanged || optiontargetfields) ?
                                                <div className='addmodel_but' onClick={()=>startmodel()}>
                                                    {langv?.open_model?.text25}
                                                </div>
                                                :
                                                <div className='addmodel_but inactive'>
                                                    {langv?.open_model?.text25}
                                                </div>
                                            }
                                            
                                        </div>
                                    </div>
                                    <div className='addmodel_fields_col'></div>
                                </>
                                :
                            
                                <div className='line_detailedeploy'>
                                    
                                    {
                                        GlobalState.activemodel?.lastTrain?.inputDatasetName||GlobalState.activemodel?.lastTrain?.outputDatasetName!=null?
                                        <>
                                            <label>{langv?.open_model?.text19}</label>
                                            <div className='detailedeploy'>
                                                
                                                {
                                                    GlobalState.activemodel?.lastTrain?.inputDatasetName!=null?
                                                    <>{langv?.open_model?.text20}: {GlobalState.activemodel?.lastTrain?.inputDatasetName}<br/></>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    GlobalState.activemodel?.lastTrain?.outputDatasetName!=null?
                                                    <>{langv?.open_model?.text21}: {GlobalState.activemodel?.lastTrain?.outputDatasetName}<br/></>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    GlobalState.activemodel?.lastTrain?.deploymentSchedule!=null?

                                                    <>{langv?.open_model?.text22} {GlobalState.activemodel?.lastTrain?.deploymentSchedule.split('T')[0]+" "+GlobalState.activemodel?.lastTrain?.deploymentSchedule.split('T')[1].split(".")[0]} UTC {GlobalState.activemodel?.lastTrain?.deploymentPeriodicity}</>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </>
                                        :
                                        <></>
                                    }
                                </div>
                                
                            }
                            
                        </div>
                        </>
                    }
                </div>
            </div>
            {
                disablebut?
            
                <div className='obs-wrapper'>
                    {obsLoading && <div className="obs-blur-overlay-tresh"><Loading text = {"Loading ..."}/></div>}
                    {
                    
                        GlobalState.activemodel?.lastTrain?.learningType=="binary"||GlobalState.activemodel?.lastTrain?.learningType=="multiclass"||GlobalState.activemodel?.lastTrain?.learningType=="regression"?
                        load!=1&&load!=4&&load!=99&&load!=0?
                            <div className='line_addish'>
                                
                                    
                                    {segments.map((seg, i) => (
                                        seg.name=="General"?
                                        
                                        <div className={activetab===0?'tab_line_addish active':'tab_line_addish'} onClick={()=>{setActivetab(0); selectSegmentGen(seg.id)}}>
                                            General
                                        </div>
                                        :
                                        <></>
                                        ))}
                                    
                                    {segments.map((seg, i) => (
                                        seg.name=="Additional"?
                                        <div
                                            key={seg.id}
                                            className={activetab === seg.id
                                            ? "tab_line_addish tab_line_addish_sec active"
                                            : "tab_line_addish tab_line_addish_sec"}
                                            onClick={() => selectSegment(seg.id)}
                                        >
                                            {/* Назва або інпут */}
                                            {editingId === seg.id ? (
                                            <input
                                                value={seg.name}
                                                
                                            />
                                            ) : (
                                            <span>{seg.name}</span>
                                            )}

                                            
                                        </div>
                                        :
                                        <></>
                                        ))}
                                
                                        <SegmentSlider 
                                            segments={segments} 
                                            activetab={activetab} 
                                            selectSegment={selectSegment}
                                            editingId={editingId}
                                            changeName={changeName}
                                            finishEdit={finishEdit}
                                            startEdit={startEdit}
                                            deleteSegment={deleteSegment} 
                                            LeftIcon={LeftIcon} 
                                            RightIcon={RightIcon} />
                                    
                                    
                                    <svg onClick={addSegment} width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M31.6131 15C31.9703 15.6188 31.9703 16.3812 31.6131 17L24.7678 28.8564C24.4105 29.4752 23.7503 29.8564 23.0357 29.8564L9.34513 29.8564C8.6306 29.8564 7.97034 29.4752 7.61308 28.8564L0.76778 17C0.410514 16.3812 0.410514 15.6188 0.76778 15L7.61308 3.14359C7.97034 2.52479 8.6306 2.14359 9.34513 2.14359L23.0357 2.14359C23.7503 2.14359 24.4105 2.52479 24.7678 3.14359L31.6131 15Z" fill="#F5C538" stroke="#F5C538"/>
                                        <path d="M16.1904 9V23" stroke="#020203" stroke-linecap="round"/>
                                        <path d="M16.1904 9V23" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                        <path d="M16.1904 9V23" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                        <path d="M9.19043 16H23.1904" stroke="#020203" stroke-linecap="round"/>
                                        <path d="M9.19043 16H23.1904" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                        <path d="M9.19043 16H23.1904" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                    </svg>

                            </div>
                            :
                            <></>
                        :
                        <></>
                    
                    }
                    
                    {
                        activetab===GENERAL_TAB_ID?
                            load==1?
                            // <Loading text = {textloading}/>
                            <></>
                            :
                            load==2?
                            <LoadingCompleted text = {textloadingcompleated}/>
                            : 
                            load==4?
                            <LoadingFail text = {textloadingcompleated}/>
                            
                            :   
                            load==3?
                            <>
                            {
                                GlobalState.activemodel?.lastTrain?.learningType=="binary"?
                                <div className='blok_metrix'>
                                    <div className='addmodel_fields_line' style={{marginBottom:'0px'}}>
                                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                        <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                        {
                                            !disablebody?
                                        
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                            :
                                            
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                        }
                                        </div>
                                    </div>
                                    {
                                        disablebody?
                                        <></>
                                        :
                                        <>
                                            <Accuracy lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                            <Contop lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>

                                            <ThresholdSlider
                                                data={doubleThresholdsData}
                                                lower={lower}
                                                upper={upper}
                                                onCommit={(lo, hi, obj) => {
                                                    setLower(lo);
                                                    setUpper(hi);
                                                    const metricId = activetab !== 0 ? activetab : null;
                                                    saveThreshold(lo, hi, metricId);
                                                    // obj = вже готовий selectedThresholdObj для метрик/табличок
                                                }}
                                            />

                                            <TabsTarget lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                            <Metric/>
                                            <Priview lower={lower} upper={upper} activemodel={activemodel.id}/>
                                        </>
                                    }
                                </div>
                                :
                                <>      
                                </>       
                            }
                            {
                                GlobalState.activemodel?.lastTrain?.learningType=="multiclass"?
                                <div className='blok_metrix'>
                                    <div className='addmodel_fields_line'>
                                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                        <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                        {
                                            !disablebody?
                                        
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                            :
                                            
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                        }
                                            
                                        </div>
                                    </div>
                                    {
                                        disablebody?
                                        <></>
                                        :
                                        <>
                                            <Accuracy lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                            <ContopNo/>
                                        
                                            <TabsTargetNo/>
                                            <Metric/>
                                            <Priview/>
                                        </>
                                    }
                                </div>
                                :
                                <>
                                    
                                </>       
                            }
                            {
                                GlobalState.activemodel?.lastTrain?.learningType=="regression"?
                                <div className='blok_metrix'>
                                    <div className='addmodel_fields_line'>
                                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                        <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                        {
                                            !disablebody?
                                        
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                            :
                                            
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                        }
                                        </div>
                                    </div>
                                    {
                                        disablebody?
                                        <></>
                                        :
                                        <>
                                            <Fourblock/>
                                            <TopField/>
                                            <Metric/>
                                            <Priview/>
                                        </>
                                    }
                                </div>
                                :
                                <>
                                </>       
                            }
                            </>
                            :
                            <></>
                        :
                        <></>
                    }
                    {/* {
                        activetab==1?
                            load==1?
                            // <Loading text = {textloading}/>
                            <></>
                            :
                            load==2?
                            <LoadingCompleted text = {textloadingcompleated}/>
                            : 
                            load==4?
                            <LoadingFail text = {textloadingcompleated}/>
                            :   
                            load==3?
                            <>
                            {
                                GlobalState.activemodel?.lastTrain?.learningType=="binary"?
                                <div className='blok_metrix'>
                                    <div className='addmodel_fields_line' style={{marginBottom:'0px'}}>
                                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                        <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                        {
                                            !disablebody?
                                        
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                            :
                                            
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                        }
                                        </div>
                                    </div>
                                    {
                                        disablebody?
                                        <></>
                                        :
                                        <>
                                            <Accuracy lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                            <Contop lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>

                                            <ThresholdSlider
                                                data={doubleThresholdsData}
                                                lower={lower}
                                                upper={upper}
                                                onCommit={(lo, hi, obj) => {
                                                    setLower(lo);
                                                    setUpper(hi);
                                                    const metricId = activetab !== 0 ? activetab : null;
                                                    saveThreshold(lo, hi, metricId);
                                                    // obj = вже готовий selectedThresholdObj для метрик/табличок
                                                }}
                                            />

                                            <TabsTarget lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                            <Metric/>
                                            <Priview lower={lower} upper={upper} activemodel={activemodel.id}/>
                                        </>
                                    }
                                </div>
                                :
                                <>      
                                </>       
                            }
                            {
                                GlobalState.activemodel?.lastTrain?.learningType=="multiclass"?
                                <div className='blok_metrix'>
                                    <div className='addmodel_fields_line'>
                                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                        <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                        {
                                            !disablebody?
                                        
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                            :
                                            
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                        }
                                            
                                        </div>
                                    </div>
                                    {
                                        disablebody?
                                        <></>
                                        :
                                        <>
                                            <Accuracy />
                                            <ContopNo />
                                            
                                            <TabsTargetNo />
                                            <Metric/>
                                            <Priview />
                                        </>
                                    }
                                </div>
                                :
                                <>
                                    
                                </>       
                            }
                            {
                                GlobalState.activemodel?.lastTrain?.learningType=="regression"?
                                <div className='blok_metrix'>
                                    <div className='addmodel_fields_line'>
                                        <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                        <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                        {
                                            !disablebody?
                                        
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                            :
                                            
                                            <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                </g>
                                            </svg>
                                            
                                        }
                                        </div>
                                    </div>
                                    {
                                        disablebody?
                                        <></>
                                        :
                                        <>
                                            <Fourblock/>
                                            <TopField/>
                                            <Metric/>
                                            <Priview />
                                        </>
                                    }
                                </div>
                                :
                                <>
                                </>       
                            }
                            </>
                            :
                            <></>
                        :
                        <></>
                    } */}
                    {
                        load==1?
                            <></>
                        :
                        activetab === 0?
                            <div className='blok_metrix' style={{display: 'none'}}>
                                <>
                                {
                                    GlobalState.activemodel?.lastTrain?.learningType=="binary"?
                                    <div className='blok_metrix blok_metrix_no_pad' >
                                        <div className='addmodel_fields_line' style={{marginBottom:'0px'}}>
                                            <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                            {/* <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                            {
                                                !disablebody?
                                            
                                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                    </g>
                                                </svg>
                                                
                                                :
                                                
                                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                    </g>
                                                </svg>
                                                
                                            }
                                            </div> */}
                                        </div>
                                        {
                                            disablebody?
                                            <></>
                                            :
                                            <>
                                                <Accuracy lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                                <Contop lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>

                                                <ThresholdSlider
                                                    data={doubleThresholdsData}
                                                    lower={lower}
                                                    upper={upper}
                                                    onCommit={(lo, hi, obj) => {
                                                        setLower(lo);
                                                        setUpper(hi);
                                                        const metricId = activetab !== 0 ? activetab : null;
                                                        saveThreshold(lo, hi, metricId);
                                                        // obj = вже готовий selectedThresholdObj для метрик/табличок
                                                    }}
                                                />

                                                <TabsTarget lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                                <Metric/>
                                                <Priview lower={lower} upper={upper} activemodel={activemodel.id}/>
                                            </>
                                        }
                                    </div>
                                    :
                                    <>      
                                    </>       
                                }
                                {
                                    GlobalState.activemodel?.lastTrain?.learningType=="multiclass"?
                                    <div className='blok_metrix blok_metrix_no_pad'>
                                        <div className='addmodel_fields_line'>
                                            <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                            <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                            {
                                                !disablebody?
                                            
                                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                    </g>
                                                </svg>
                                                
                                                :
                                                
                                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                    </g>
                                                </svg>
                                                
                                            }
                                                
                                            </div>
                                        </div>
                                        {
                                            disablebody?
                                            <></>
                                            :
                                            <>
                                                <Accuracy />
                                                <ContopNo />
                                                <TabsTargetNo />
                                                <Metric/>
                                                <Priview />
                                            </>
                                        }
                                    </div>
                                    :
                                    <>
                                        
                                    </>       
                                }
                                {
                                    GlobalState.activemodel?.lastTrain?.learningType=="regression"?
                                    <div className='blok_metrix blok_metrix_no_pad' >
                                        <div className='addmodel_fields_line'>
                                            <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                            <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                            {
                                                !disablebody?
                                            
                                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                    <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                    </g>
                                                </svg>
                                                
                                                :
                                                
                                                <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                    <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                    <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                    </g>
                                                </svg>
                                                
                                            }
                                            </div>
                                        </div>
                                        {
                                            disablebody?
                                            <></>
                                            :
                                            <>
                                                <Fourblock/>
                                                <TopField/>
                                                <Metric/>
                                                <Priview />
                                            </>
                                        }
                                    </div>
                                    :
                                    <>
                                    </>       
                                }
                                </>
                            </div>
                            :
                            <></>
                    }
                    {
                        load==1?
                            <Loading text = {textloadingSeg}/>
                        :
                        segments.map((seg, i) => (
                            
                            activetab === seg.id?
                            <div className='blok_metrix' >
                                
                                {
                                    load==77?
                                    <></>
                                    :
        
                                    seg.name!="Additional"?
                                    
                                    <CreateSegmentationBlock
                                        key={seg.id}
                                        segmentName={seg.name}
                                        modelId={GlobalState.activemodel?.id}
                                        onEditAttribute={handleEdit}
                                        datasetId={GlobalState.activemodel?.lastTrain?.featureDataset}
                                        initialSegmentConditions={activeSegmentMeta}
                                        additionOff={metadata.length}
                                        readOnly={!isNewSegment}   
                                    />
                                    :
                                    <></>
                                }
                                
                                {
                                    load==2?
                                    <LoadingCompleted text = {textloadingcompleated}/>
                                    : 
                                    <></>
                                }
                                {
                                    load==4?
                                    <LoadingFail text = {textloadingcompleated}/>
                                    :
                                    <></>
                                }
                                
                                {
                                    load==77?
                                    <LoadingFail text = {textloadingcompleated}/>
                                    :
                                    <></>
                                }
                                {
                                    seg.id.includes("test")?
                                        <div className='select_line_segments_2 select_line_segments_3'>
                                            <div className='select_line_segments_f select_line_segments_f_new_name select_line_segments_f_new_name_answer'>
                                                Testing details
                                            </div>
                                            <div className="select_line_segments_f_new_answer">
                                            {/* <svg width="101" height="99" viewBox="0 0 101 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M50.5 30.5C78.1142 30.5 100.5 23.7843 100.5 15.5C100.5 7.21573 78.1142 0.5 50.5 0.5C22.8858 0.5 0.5 7.21573 0.5 15.5C0.5 23.7843 22.8858 30.5 50.5 30.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M17.4272 26.75C7.04695 29.4985 0.5 33.52 0.5 38C0.5 46.2843 22.8857 53 50.5 53C78.1143 53 100.5 46.2843 100.5 38C100.5 33.52 93.953 29.4985 83.5727 26.75C74.7588 29.0838 63.1805 30.5 50.5 30.5C37.8195 30.5 26.2412 29.0838 17.4272 26.75Z" fill="#2F88FF" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M17.4272 49.25C7.04695 51.9985 0.5 56.02 0.5 60.5C0.5 68.7842 22.8857 75.5 50.5 75.5C78.1143 75.5 100.5 68.7842 100.5 60.5C100.5 56.02 93.953 51.9985 83.5727 49.25" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M17.4272 71.75C7.04695 74.4985 0.5 78.52 0.5 83C0.5 91.2842 22.8857 98 50.5 98C78.1143 98 100.5 91.2842 100.5 83C100.5 78.52 93.953 74.4985 83.5727 71.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg> */}
                                                <TestingSegmentsLoopSwap />
                                            <p style={{marginTop: '0px'}}>Please select testing segment</p>
                                            </div>
                                        </div>
                                    :
                                    <></>
                                }
                                {   
                                    load==3?
                                        
                                        // seg.lastTrain?.metadata?.metrics!=null?
                                        seg.id.includes("test")?
                                        <></>
                                        :
                                        <>
                                        {
                                            GlobalState.activemodel?.lastTrain?.learningType=="binary"?
                                            <div className='blok_metrix blok_metrix_no_pad' >
                                                <div className='addmodel_fields_line' style={{marginBottom:'0px'}}>
                                                    <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                                    {/* <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                                    {
                                                        !disablebody?
                                                    
                                                        <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.4">
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                            </g>
                                                        </svg>
                                                        
                                                        :
                                                        
                                                        <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.4">
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                            </g>
                                                        </svg>
                                                        
                                                    }
                                                    </div> */}
                                                </div>
                                                {
                                                    disablebody?
                                                    <></>
                                                    :
                                                    <>
                                                        <Accuracy lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                                        <Contop lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>

                                                        <ThresholdSlider
                                                            data={doubleThresholdsData}
                                                            lower={lower}
                                                            upper={upper}
                                                            onCommit={(lo, hi, obj) => {
                                                                setLower(lo);
                                                                setUpper(hi);
                                                                const metricId = activetab !== 0 ? activetab : null;
                                                                saveThreshold(lo, hi, metricId);
                                                                // obj = вже готовий selectedThresholdObj для метрик/табличок
                                                            }}
                                                        />

                                                        <TabsTarget lower={lower} upper={upper} thresholdData={selectedThresholdObj}/>
                                                        <Metric/>
                                                        <Priview lower={lower} upper={upper} activemodel={activemodel.id}/>
                                                    </>
                                                }
                                            </div>
                                            :
                                            <>      
                                            </>       
                                        }
                                        {
                                            GlobalState.activemodel?.lastTrain?.learningType=="multiclass"?
                                            <div className='blok_metrix blok_metrix_no_pad'>
                                                <div className='addmodel_fields_line'>
                                                    <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                                    <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                                    {
                                                        !disablebody?
                                                    
                                                        <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.4">
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                            </g>
                                                        </svg>
                                                        
                                                        :
                                                        
                                                        <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.4">
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                            </g>
                                                        </svg>
                                                        
                                                    }
                                                        
                                                    </div>
                                                </div>
                                                {
                                                    disablebody?
                                                    <></>
                                                    :
                                                    <>
                                                        <Accuracy />
                                                        <ContopNo />
                                                        <TabsTargetNo />
                                                        <Metric/>
                                                        <Priview />
                                                    </>
                                                }
                                            </div>
                                            :
                                            <>
                                                
                                            </>       
                                        }
                                        {
                                            GlobalState.activemodel?.lastTrain?.learningType=="regression"?
                                            <div className='blok_metrix blok_metrix_no_pad' >
                                                <div className='addmodel_fields_line'>
                                                    <div className='addmodel_fields_line_title'>{langv?.open_model?.text23}</div>
                                                    <div className='icon_disable' onClick={()=>setDisablebody(!disablebody)}>
                                                    {
                                                        !disablebody?
                                                    
                                                        <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.4">
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="#020203"/>
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.61523 3.07617)" fill="black" fillOpacity="0.2"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="#020203"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                            <path d="M1 3.84615L7.34033 10L13.3077 3.84615" stroke="black" strokeOpacity="0.2"/>
                                                            </g>
                                                        </svg>
                                                        
                                                        :
                                                        
                                                        <svg className='def_icon' width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.4">
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="#020203"/>
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                            <circle cx="7.1537" cy="9.46229" r="1.53846" fill="black" fillOpacity="0.2"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="#020203"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                            <path d="M1 7.15385L7.34033 1L13.3077 7.15385" stroke="black" strokeOpacity="0.2"/>
                                                            </g>
                                                        </svg>
                                                        
                                                    }
                                                    </div>
                                                </div>
                                                {
                                                    disablebody?
                                                    <></>
                                                    :
                                                    <>
                                                        <Fourblock/>
                                                        <TopField/>
                                                        <Metric/>
                                                        <Priview />
                                                    </>
                                                }
                                            </div>
                                            :
                                            <>
                                            </>       
                                        }
                                        </>
                                        // :
                                        // // <LoadingFail text = {textloadingcompleated}/>
                                        // <></>
                                    :
                                    <></>
                                }
                            </div>
                            :
                            <></>
                        ))
                    }
                    {
                        load==99?
                        <LoadingFailDetail text = {GlobalState.activemodel?.lastTrain?.errors?.[0]?.code||""}/>
                        :
                        <></>
                    }
                </div>
                :
                <></>
            }
        </div>
    );
})

export default Addmodels;
